import { Link, NavLink } from "react-router-dom";
import { AccMark } from "./AccMark";
import { BRAND } from "@/data/site";
import { CallButton, QuoteButton } from "./Cta";

const NAV = [
  { to: "/#services", label: "Services" },
  { to: "/#areas", label: "Areas" },
  { to: "/projects", label: "Gallery" },
  { to: "/blog", label: "Blog" },
];

export function Logo() {
  return (
    <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
      <AccMark className="h-9 w-auto" />
      <span className="hidden leading-none sm:inline">
        <span className="block font-display text-lg font-bold uppercase tracking-wide text-white">All Concept</span>
        <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Concrete</span>
      </span>
    </Link>
  );
}

export default function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-[#0F1115]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="font-display text-base font-semibold uppercase tracking-wider text-slate-300 transition-colors hover:text-brand-400"
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <QuoteButton id="header-quote-cta" className="btn-ghost hidden !py-2 lg:inline-flex" label="Get Quote" />
          <CallButton id="header-phone-cta" className="btn-brand whitespace-nowrap !px-4 !py-2 text-base" label={<><span className="sm:hidden">Call</span><span className="hidden sm:inline">Call {BRAND.phone}</span></>} />
        </div>
      </div>
    </header>
  );
}
